import { gt, filter, includes, some, lt, size } from 'lodash';
import { ITransferData, IQohInventoryItemVenue } from '../types';
import { TRANSFER_STATUS_VALUE } from '../types/enums/transfer-status.enum';
import { TRANSFER_UNSAVED_STATUS } from '../services/transfer/transfer.definition';
import { flatTreeDataByHasChildren } from './common-utils';
import { ITreeData } from '../types/common/tree.type';
import { XVII18nService } from '@app/i18n/services';
import { I18n } from '@app/i18n/strings-keys';

const getUnsavedMessage = (
  unsavedCount: number,
  options: {
    i18nService: XVII18nService;
  },
): string => {
  return gt(unsavedCount, 0)
    ? options.i18nService.translate(
        I18n.InfoMessages.CountsUnsavedChangesMessageMade,
        {
          changeCount: unsavedCount,
        },
      )
    : '';
};

const getUnsavedChangeInfo = (
  transfers: ITransferData[],
  options: {
    i18nService: XVII18nService;
  },
): {
  unsavedCount: number;
  unsavedMessage: string;
} => {
  const unsavedCount = size(
    filter(transfers, {
      isChanged: true,
    }),
  );

  return {
    unsavedCount,
    unsavedMessage: getUnsavedMessage(unsavedCount, options),
  };
};

const getNewTransferStatus = (
  nowStatus: TRANSFER_STATUS_VALUE | string,
  inventoryItems: (ITreeData | IQohInventoryItemVenue)[],
  isClearChange: boolean = false,
): TRANSFER_STATUS_VALUE | string => {
  let newStatus = nowStatus;
  if (includes(TRANSFER_UNSAVED_STATUS, newStatus)) {
    if (isClearChange) {
      newStatus = TRANSFER_STATUS_VALUE.Null;
    } else {
      const flattenInventoryItems = flatTreeDataByHasChildren(
        inventoryItems as IQohInventoryItemVenue[],
      );

      const isHaveValidData = some(
        flattenInventoryItems,
        (inventoryItem) =>
          gt(inventoryItem['count'], 0) ||
          lt(inventoryItem['count'], 0) ||
          gt(inventoryItem['initial_count'], 0) ||
          lt(inventoryItem['initial_count'], 0),
      );
      newStatus = isHaveValidData
        ? TRANSFER_STATUS_VALUE.New
        : TRANSFER_STATUS_VALUE.Null;
    }
  }

  return newStatus;
};

export { getUnsavedMessage, getUnsavedChangeInfo, getNewTransferStatus };
